var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.documentType === "image"
    ? _c("img", {
        attrs: { src: _vm.url, alt: _vm.$t("global.words.document") },
      })
    : _c(
        "div",
        { staticClass: "iframe-container position-relative" },
        [
          _c("documents-previewer-loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loadingIFrame || _vm.loading,
                expression: "loadingIFrame || loading",
              },
            ],
            staticClass: "document-preview-loader",
          }),
          _vm._v(" "),
          _vm.url && !_vm.forceReload
            ? _c("iframe", {
                ref: "docIFrame",
                attrs: {
                  id: "preview-iFrame",
                  title: "Document Previewer",
                  src: _vm.docPreviewURL,
                },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }